const STORAGE_KEY = "mdsync.selectedOrganizationId";
const EVENT_NAME = "mdsync:organization-changed";

export const organizationContext = {
  getSelectedOrganizationId(): string | null {
    return globalThis.localStorage?.getItem(STORAGE_KEY) ?? null;
  },
  setSelectedOrganizationId(organizationId: string): void {
    globalThis.localStorage?.setItem(STORAGE_KEY, organizationId);
    globalThis.dispatchEvent(
      new CustomEvent(EVENT_NAME, { detail: { organizationId } }),
    );
  },
  clear(): void {
    globalThis.localStorage?.removeItem(STORAGE_KEY);
    globalThis.dispatchEvent(new CustomEvent(EVENT_NAME, { detail: null }));
  },
  subscribe(listener: (organizationId: string | null) => void): () => void {
    const handler = (event: Event) => {
      const custom = event as CustomEvent<{ organizationId?: string } | null>;
      listener(custom.detail?.organizationId ?? null);
    };
    globalThis.addEventListener(EVENT_NAME, handler);
    return () => globalThis.removeEventListener(EVENT_NAME, handler);
  },
};
